import ajax from "../../authenticationSafeAjax";

export default function (callback) {
    ajax({url:"/TradeIdeasMonitor/ui/api/openIdeas"},
        (code, text) => {
            callback(text)
        }
    );
}
